module.exports = {"130984100":"瀛州镇","130984101":"米各庄镇","130984102":"景和镇","130984103":"卧佛堂镇","130984104":"束城镇","130984105":"留古寺镇","130984106":"沙河桥镇","130984200":"故仙乡","130984201":"黎民居乡","130984202":"兴村乡","130984203":"沙洼乡","130984204":"西九吉乡","130984205":"北石槽乡","130984207":"诗经村乡","130984208":"郭家村乡","130984209":"时村乡","130984210":"行别营乡","130984211":"尊祖庄乡","130984212":"龙华店乡","130984213":"果子洼回族乡","130984401":"河间经济开发区管理委员会","130984402":"河北河间瀛州经济开发区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130984.json
// module id = 205
// module chunks = 0